import { useEffect, useLayoutEffect, useState } from "react";
import { MdHistory, MdOutlineColorLens, MdOutlineCreditCard, MdOutlineMarkEmailRead, MdPeopleOutline, MdTune, MdWeb } from "react-icons/md";
import { PiLightning, PiLightningThin, PiPlugs, PiSparkleLight } from "react-icons/pi";
import { TbGalaxy, TbInfoSquare, TbListSearch, TbLock, TbLogs, TbWorldCog } from "react-icons/tb";
import { VscHubot, VscOrganization } from "react-icons/vsc";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../Components/Spinner";
import { HiLogout, HiOutlineChartBar, HiSparkles, HiViewGrid } from "react-icons/hi";
import MainFrameLoader from "../Loaders/MainFrameLoader";
import { Dropdown } from "react-bootstrap";
import { RiKey2Line, RiSeoLine } from "react-icons/ri";
import { TiCloudStorageOutline } from "react-icons/ti";
import { BiGlobe, BiNetworkChart, BiUser } from "react-icons/bi";
import { IoAppsOutline, IoChatboxOutline, IoLanguage, IoSearchOutline, IoStatsChartOutline } from "react-icons/io5";
import { CiBoxList, CiDark, CiLight, CiMonitor } from "react-icons/ci";
import { GoDotFill, GoSidebarCollapse, GoSidebarExpand } from "react-icons/go";
import { IoIosCodeWorking, IoMdReturnLeft } from "react-icons/io";
import LogoutModal from "./LogoutModal";
import { LuListTree, LuWorkflow } from "react-icons/lu";
import { GiSparkles } from "react-icons/gi";
import { BsBarChart, BsEyeSlash, BsFolder } from "react-icons/bs";
import { ImNewTab } from "react-icons/im";
import { useLanguage } from "../Translations/LenguageContext";

const MainFrameSidebar = ({
    account_id,
    openSidebar = false,
    toggleSidebar,
    loading,
    userData,
    setShowProfileModal,
    setShowSettingsModal,
    setWorkspaceType,
    workspaceType,
    singleOrgData,
    loadingSingleOrg,
    fetchSingleOrganization,
    fetchChatHistory,
    chatData,
    loadingChatData
}) => {
    const { t, changeLanguage } = useLanguage()
    const location = useLocation();
    const navigate = useNavigate();
    const [loadingLogout, setLoadingLogout] = useState(false);
    const [showLogoutModal, setShowModalLogout] = useState(false)
    const [isLanguage, setLanguageOpen] = useState(false)
    const pathSegments = location.pathname.split("/");
    const isOrgContext = pathSegments[2] === "organizations" && pathSegments[3];
    const orgId = isOrgContext ? pathSegments[3] : null;

    const currentActiveRoute = isOrgContext ? pathSegments[4] : pathSegments[2];

    const value = localStorage.getItem("abstshow-abilities-popup");

    const [showMoreAbilitiesPopup, setShowMoreAbilitiesPopup] = useState(() => {
        if (value === null || value === "null") return true;
        return value !== "false";
    });

    const orgName = singleOrgData?.name
    const orgRole = singleOrgData?.role
    const [themesContOpen, setThemesContOpen] = useState(false)
    const [workbenchOpen, setWorkbenchOpen] = useState(false)
    const [languageType, setLanguageType] = useState(() => {
        const saved = localStorage.getItem("abstlanguage");
        return saved ? saved : "en";
    });


    const adminNavGroups = [
        {
            title: t.sidebar.create,
            items: [
                { route: "organizations", label: t.sidebar.organizations, Icon: VscOrganization },
                { route: "members", label: t.sidebar.members, Icon: MdPeopleOutline },
                { route: "api-keys", label: t.sidebar.api_keys, Icon: RiKey2Line },
            ],
        },
        {
            title: t.sidebar.manage,
            items: [
                { route: "billing/wallet", label: t.sidebar.billing, Icon: MdOutlineCreditCard },
                { route: "analytics/api-requests", label: t.sidebar.analytics, Icon: HiOutlineChartBar },
            ],
        },
        {
            title: t.sidebar.monitor,
            items: [
                { route: "logs", label: t.sidebar.logs, Icon: TbLogs },
            ],
        },

    ];

    const organizationNavgroup = [
        {
            title: t.sidebar.create,
            items: [
                // {
                //     route: "chat/new-chat",
                //     label: "New chat",
                //     Icon: IoChatboxOutline,
                //     roles: ["owner", "manager", "developer", "member"],
                //     locked: true
                // },
                // {
                //     route: "chat-history",
                //     label: t.sidebar.chat_history,
                //     Icon: MdHistory,
                //     roles: ["owner", "manager", "developer", "member"],
                //     locked: false
                // },
                // {
                //     route: "ads",
                //     label: "Ads",
                //     Icon: BsBarChart,
                //     roles: ["owner", "developer"],
                //     locked: true
                // },
                {
                    route: "context",
                    label: "Context",
                    Icon: TbInfoSquare,
                    roles: ["owner", "developer"],
                    locked: false
                },
                {
                    route: "properties",
                    label: "Properties",
                    Icon: LuListTree,
                    roles: ["owner", "developer"],
                    locked: false
                },
                {
                    route: "geo",
                    label: "GEO",
                    Icon: RiSeoLine,
                    roles: ["owner", "developer"],
                    locked: false
                },
                // {
                //     route: "seo",
                //     label: "SEO",
                //     Icon: IoSearchOutline,
                //     roles: ["owner", "developer"],
                //     locked: true
                // },
                // {
                //     route: "email-marketing",
                //     label: "Email marketing",
                //     Icon: MdOutlineMarkEmailRead,
                //     roles: ["owner", "developer"],
                //     locked: true
                // },
                // {
                //     route: "leads",
                //     label: "Leads",
                //     Icon: TbListSearch,
                //     roles: ["owner", "developer"],
                //     locked: true
                // },
                  {
                    route: "manage-org/settings",
                    label: "Settings",
                    Icon: TbWorldCog,
                    roles: ["owner", "admin"],
                }
            ],
        },


        {
            title: "Recent",
            items: [
               
            ],
        },
    ];


    const handleLanguageChange = (lan) => {
        changeLanguage(lan);
        setLanguageType(lan)
    };

    const toggleThemeCont = () => {
        themesContOpen ? setThemesContOpen(false) : setThemesContOpen(true)
        workbenchOpen && setWorkbenchOpen(false)
        isLanguage && setLanguageOpen(false)
    }

    const toggleWorkbench = () => {
        workbenchOpen ? setWorkbenchOpen(false) : setWorkbenchOpen(true)
        themesContOpen && setThemesContOpen(false)
        isLanguage && setLanguageOpen(false)
    }

    const toggleLanguage = () => {
        isLanguage ? setLanguageOpen(false) : setLanguageOpen(true)
        themesContOpen && setThemesContOpen(false)
        workbenchOpen && setWorkbenchOpen(false)
    }

    const [appearance, setAppearance] = useState(() => {
        return localStorage.getItem("absttheme-preference") || "system";
    });

    useEffect(() => {
        const root = window.document.documentElement;
        const applyTheme = (theme) => {
            let themeToSet = theme;
            if (theme === "system") {
                themeToSet = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            }
            root.setAttribute("data-theme", themeToSet);
            localStorage.setItem("absttheme-preference", theme);
            window.dispatchEvent(new Event("absttheme-changed"));
        };
        applyTheme(appearance);
    }, [appearance]);

    const handleLogout = () => {
        setLoadingLogout(true);
        localStorage.removeItem("account_id");
        document.cookie = "account_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        setTimeout(() => navigate("/login"), 1000);
    };

    const handleNavClick = (route) => {
        if (isOrgContext) {
            navigate(`/console/organizations/${orgId}/${route}`);
        } else {
            navigate(`/console/${route}`);
        }
    };

    useEffect(() => {
        fetchSingleOrganization(orgId);
    }, [orgId]);

    const ToggleIcon = openSidebar ? GoSidebarExpand : GoSidebarCollapse;
    const sidebarClass = `mainframe_sidebar ${openSidebar ? "mainframe_sidebar_open" : "mainframe_sidebar_closed"}`;

    const filteredOrganizationNavgroup = organizationNavgroup
        .map(group => {
            const filteredItems = group.items.filter(item =>
                item.roles.includes(orgRole)
            );

            if (filteredItems.length === 0) return null;

            return {
                ...group,
                items: filteredItems,
            };
        })
        .filter(Boolean);
    const activeGroups = isOrgContext
        ? filteredOrganizationNavgroup
        : adminNavGroups;

    const hideAbilitiesPopup = () => {
        setShowMoreAbilitiesPopup(false)
        localStorage.setItem("abstshow-abilities-popup", false)
    }


    if ((loading && !userData) || loadingSingleOrg) return <MainFrameLoader />;

    return (
        <div className={sidebarClass}>
            <div className="mainframe_sidebar_header">
                <div className="logo_toggle_wrapper fade-in">
                    <div className="mainframe_sidebar_logo_org">
                        {!openSidebar && (
                            <i
                                className="mainframe_sidebar_logo"
                                style={{ cursor: "pointer" }}
                            >
                                <TbGalaxy />
                            </i>
                        )}
                        {openSidebar && (
                            isOrgContext ? (
                                loadingSingleOrg ? (
                                    <div className="loading_sidebar_single"></div>
                                ) : (
                                    <p
                                        className="fade-in"
                                    >
                                        {orgName}
                                    </p>
                                )
                            ) : (
                                <p
                                    className="fade-in"
                                >
                                    Abstracht
                                </p>
                            )
                        )}
                    </div>
                    <button type="button" className="sidebar_home_toggle" onClick={toggleSidebar}>
                        <ToggleIcon />
                    </button>
                </div>
            </div>

            <div className="mainframe_sidebar_body">
                <nav>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {activeGroups.map((group) => (
                            <div key={group.title} className="sidebar_group_cont">
                                <p className={`nav_group_title ${!openSidebar ? "inner_link_text_hidden" : ""}`}>
                                    {group.title}
                                </p>

                                {group.items.map(({ route, label, Icon, locked }) => {
                                    const routeBase = route.split('/')[0];
                                    const isActive = currentActiveRoute === routeBase;
                                    return (
                                        <li key={route}>
                                            <button
                                                type="button"
                                                className={`mainframe_sidebar_link fade-in ${isActive ? "selected_mainframe_sidebar_link" : ""} ${openSidebar ? "mainframe_sidebar_link_open" : "mainframe_sidebar_link_closed"}
                                                ${locked && "mainframe_sidebar_link_locked"}
                                                `}
                                                onClick={() => {
                                                    if (locked) return;
                                                    handleNavClick(route);
                                                }}
                                            >
                                                {locked ? (
                                                    <i><TbLock /></i>
                                                ) : (
                                                    <i><Icon /></i>
                                                )}
                                                <span className={`inner_link_text ${!openSidebar ? "inner_link_text_hidden" : ""}`}>
                                                    {label} {" "}
                                                    {locked && (
                                                        <span className="inner_link_text_small">
                                                            (Building)
                                                        </span>
                                                    )}
                                                </span>
                                            </button>
                                            {/* {label === "Playground" && openSidebar && (
                                                <div className="sidebar_chat_list_container fade-in">
                                                    {chatData.length === 0 ? (
                                                        <p className="sidebar_no_chats_text">No chats available</p>
                                                    ) : (
                                                        chatData
                                                            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                                            .slice(0, 3)
                                                            .map((chat) => {
                                                                const isChatActive = location.pathname.includes(chat.id);

                                                                return (
                                                                    <button
                                                                        key={chat.id}
                                                                        className={`sidebar_chat_item ${isChatActive ? "active_chat_item" : ""}`}
                                                                        onClick={() => navigate(`/console/organizations/${orgId}/playground/${chat.id}`)}
                                                                    >
                                                                        <span className="truncate_text">{chat.name}</span>
                                                                    </button>
                                                                );
                                                            })
                                                    )}
                                                </div>
                                            )} */}

                                            {/* {label === "Fine-tune" && openSidebar && (
                                                <div className="sidebar_chat_list_container fade-in">
                                                    <button
                                                        className={`sidebar_chat_item`}
                                                        onClick={() => navigate(`/console/organizations/${orgId}/fine-tune`)}
                                                    >
                                                        <span className="truncate_text">Jobs</span>
                                                    </button>
                                                    <button
                                                        className={`sidebar_chat_item`}
                                                        onClick={() => navigate(`/console/organizations/${orgId}/my-models`)}
                                                    >
                                                        <span className="truncate_text">Models</span>
                                                    </button>
                                                </div>
                                            )} */}

                                        </li>
                                    );
                                })}
                            </div>
                        ))}
                    </ul>
                </nav>
                {/* {openSidebar && isOrgContext && (
                    <div className="sidebar_messages_cont">
                        {showMoreAbilitiesPopup && (
                            <div className="sidebar_message fade-in">
                                <p className="sidebar_message_title">{t.sidebar.alert_abilities.title} <button className="sidebar_message_title_btn" onClick={hideAbilitiesPopup}><BsEyeSlash /></button>
                                </p>
                                <p className="sidebar_message_description">{t.sidebar.alert_abilities.subtitle}</p>
                                <div className="sidebar_message_btn_cont">
                                    <a
                                        href="/directories/abilities"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="sidebar_message_btn"
                                    >
                                        <span><ImNewTab /> {t.sidebar.alert_abilities.btn}</span>
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>
                )} */}

                {openSidebar && !userData.payment_method && (
                    <div className="sidebar_message fade-in">
                        <p className="sidebar_message_title">{t.sidebar.alert_payment.title}</p>
                        <p className="sidebar_message_description">{t.sidebar.alert_payment.subtitle}</p>
                        <div className="sidebar_message_btn_cont">
                            <button className="sidebar_message_btn" onClick={() => navigate("/console/billing/wallet")}>
                                <span>{t.sidebar.alert_payment.btn}</span>
                            </button>
                        </div>
                    </div>
                )}
            </div>


            {
                isOrgContext && (
                    <div className="sidebar_group_cont" style={{ marginTop: 'auto', marginBottom: '10px' }}>
                        <button
                            type="button"
                            className={`mainframe_sidebar_link exit_org_link ${openSidebar ? "mainframe_sidebar_link_open" : "mainframe_sidebar_link_closed"}`}
                            onClick={() => navigate("/console/organizations")}
                        >
                            <i><IoMdReturnLeft /></i>
                            {openSidebar && <span className="inner_link_text">{t.sidebar.admin_panel}</span>}
                        </button>
                    </div>
                )
            }

            <Dropdown autoClose={"outside"}>
                <Dropdown.Toggle as="div" className="custom-toggle-user" >
                    <button className={`mainframe_sidebar_footer fade-in ${!openSidebar ? "footer_closed" : ""}`}>
                        <div className="user_image fade-in">
                            {userData?.profile_url ? (
                                <div className="user_image_url" style={{ backgroundImage: `url(${userData.profile_url})` }} />
                            ) : (
                                <div>
                                    {userData?.name?.charAt(0).toUpperCase()}
                                    {userData?.surname?.charAt(0).toUpperCase()}
                                </div>
                            )}
                        </div>

                        {userData && openSidebar && (
                            <span className="mainframe_sidebar_footer_info">
                                <p className="mainframe_sidebar_footer_user fade-in">
                                    {userData.name} {userData.surname}
                                </p>
                                {isOrgContext && (
                                    loadingSingleOrg ? (
                                        <div className="loading_sidebar_single_thin"></div>
                                    ) : (
                                        <p className="mainframe_sidebar_footer_role fade-in">
                                            {orgRole?.charAt(0).toUpperCase() + orgRole?.slice(1)}
                                        </p>
                                    )
                                )}

                            </span>
                        )}
                    </button>
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom_dropdown_menu">
                    <div className="dropdown_container fade-in">
                        {/* <button className="settings_link themes_trigger" onClick={toggleWorkbench}>
                            <div className="settings_sublink_themes_trigger">
                                <i><HiViewGrid /></i> {t.sidebar.workspace}
                            </div>
                            <span className="submenu_arrow">
                                <i className={`fa-solid fa-chevron-right ${workbenchOpen ? "chevron_rotate" : ""}`}></i>
                            </span>
                        </button>
                        <div className={`themes_flyout ${workbenchOpen ? "" : "themes_flyout_closed"}`}>
                            <button
                                className="settings_link"
                                onClick={() => setWorkspaceType("console")}
                            >
                                <i><IoIosCodeWorking /></i> E8 Console
                                {workspaceType == "console" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button>
                            <button
                                className="settings_link"
                                onClick={() => setWorkspaceType("orion")}
                            >
                                <i><PiSparkleLight /></i> Orion
                                {workspaceType == "orion" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button> 

                        </div>*/}

                        <button className="settings_link themes_trigger" onClick={toggleLanguage}>
                            <div className="settings_sublink_themes_trigger">
                                <i><IoLanguage /></i> {t.sidebar.language}
                            </div>
                            <span className="submenu_arrow">
                                <i className={`fa-solid fa-chevron-right ${isLanguage ? "chevron_rotate" : ""}`}></i>
                            </span>
                        </button>
                        <div className={`themes_flyout ${isLanguage ? "" : "themes_flyout_closed"}`}>
                            <button
                                className="settings_link"
                                onClick={() => handleLanguageChange("en")}
                            >
                                English
                                {languageType == "en" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button>
                            <button
                                className="settings_link"
                                onClick={() => handleLanguageChange("it")}
                            >
                                Italiano
                                {languageType == "it" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button>

                        </div>

                        <button className="settings_link themes_trigger" onClick={toggleThemeCont}>
                            <div className="settings_sublink_themes_trigger">
                                <i><MdOutlineColorLens /></i> {t.sidebar.theme}
                            </div>
                            <span className="submenu_arrow">
                                <i className={`fa-solid fa-chevron-right ${themesContOpen ? "chevron_rotate" : ""}`}></i>
                            </span>
                        </button>

                        <div className={`themes_flyout ${themesContOpen ? "" : "themes_flyout_closed"}`}>
                            <button
                                className="settings_link"
                                onClick={() => setAppearance("light")}
                            >
                                <i><CiLight /></i> {t.onboarding.experience.light}
                                {appearance == "light" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button>
                            <button
                                className="settings_link"
                                onClick={() => setAppearance("dark")}
                            >
                                <i><CiDark /></i> {t.onboarding.experience.dark}
                                {appearance == "dark" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>
                                )}
                            </button>
                            <button
                                className="settings_link"
                                onClick={() => setAppearance("system")}
                            >
                                <i><CiMonitor /></i> {t.onboarding.experience.system}
                                {appearance == "system" && (
                                    <i className="settings_link_dot"><GoDotFill /></i>

                                )}
                            </button>
                        </div>


                        <button className="settings_link" onClick={() => setShowProfileModal(true)}>
                            <i><BiUser /></i> {t.sidebar.profile}
                        </button>

                        <button className="settings_link" onClick={() => setShowModalLogout(true)}>
                            {loadingLogout ? <i><Spinner loading /></i> : <i><HiLogout /></i>}
                            {t.sidebar.logout}
                        </button>
                    </div>
                </Dropdown.Menu>
            </Dropdown>

            <LogoutModal
                show={showLogoutModal}
                handleClose={() => setShowModalLogout(false)}
                handleLogout={handleLogout}
                loadingLogout={loadingLogout}
                userEmail={userData?.email}
            />
        </div >
    );
};

export default MainFrameSidebar;